import { useAppDispatch } from "../../../../redux/hooks";

import { CellsNomenclatureListInterface } from "../../../../redux/interfaces/admin.interface";
import CustomButton from "../../../../components/CustomButton";
import { adminRoutes } from "../../../../router/routesConstants";
import {
  fetchDeleteCellNomenclature,
  getPrintCellNomenclature,
} from "../../../../redux/api/admin.api";
import SvgIcon from "../../../../helpers/SvgIcon";

function CellsNomenclatureActionButton({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: CellsNomenclatureListInterface;
}) {
  const dispatch = useAppDispatch();

  const { idCelula } = crudData;

  const handleDeleteCellNomenclature = () => {
    dispatch(
      fetchDeleteCellNomenclature({
        idCelula: idCelula,
      }),
    );
  };

  const goToUpdateCellNomenclature = () => {
    if (idCelula) {
      return `${itemId}/${adminRoutes.editCellNomenclature}?idCelula=${idCelula}`;
    }
  };

  const handleDownloadBarCodeOfCell = () => {
    dispatch(
      getPrintCellNomenclature({
        idCelula: idCelula,
      }),
    );
  };

  return (
    <div>
      <CustomButton
        variant="contained"
        tooltipTitle="Editeaza"
        className="mt-1 me-1"
        navigate={goToUpdateCellNomenclature()}>
        <SvgIcon type="EDIT" />
      </CustomButton>

      <CustomButton
        variant="contained"
        tooltipTitle="Printeaza"
        className="me-1 mt-1"
        withConfirmationModal={{
          modalTitle: `Doriti sa tipariti codul de bare pentru celula curenta?`,
          modalLeftButtonVariant: "outlined",
          modalRightButtonOnClick: handleDownloadBarCodeOfCell,
        }}>
        <SvgIcon type="PRINT" />
      </CustomButton>

      <CustomButton
        variant="contained"
        tooltipTitle="Sterge"
        color="error"
        className="mt-1 me-1"
        withConfirmationModal={{
          modalLeftButtonVariant: "outlined",
          modalTitle: `Doriti sa stergeti celula ?`,
          modalRightButtonOnClick: handleDeleteCellNomenclature,
        }}>
        <SvgIcon type="DELETE" />
      </CustomButton>
    </div>
  );
}

export default CellsNomenclatureActionButton;
